import React from 'react';

const Footer = () => {
    return (
            <div className="app-footer">
                <p className="footer-logo app-footer-left">Supp</p>
                <div className="app-footer-right">
                    <div>© 2018 Supp</div>
                    <div>Privacy</div>
                    <div>Terms</div>
                </div>
            </div>
    );
};

export default Footer;